import { Modal } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';
import crossbtn from './../../assets/images/x.png'
import * as queries from "../../utils/prismicQueries";
import client from "../../utils/prismicHelpers";
const Notification = () => {
    const [showNotification, setShowNotification] = useState(false)
    const [notifications, setNotification] = useState(null)
    useEffect(() => {
        client
            .query({
                query: queries.notifications,
            })
            .then((response) => {
                const notificationDoc = response.data.allNotifications.edges[0].node;
                setNotification(notificationDoc?.notifictions);
                setTimeout(() => {
                    const endDate = new Date(notificationDoc?.notifictions[0]?.date);
                    const dateRemaining = Math.round((endDate.getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24));
                    if (dateRemaining >= 0) {
                        setShowNotification(true);
                    }
                    else {
                        setShowNotification(false);
                    }
                }, 3000);
            })
            .catch((error) => {
                console.error(error);
            });


    }, []);
    return (
        <>
            {showNotification &&
                <div className="container-fluid py-0 my-0 notific-container">
                    <div className="d-flex justify-content-between align-items-center">
                        <p className="py-2 m-0">Lorem ipsum dolor sit amet consectetur, Lorem ipsum dolor sit amet  adipisicing elit. Fugit, corporis voluptate quisquam aliquam vitae dolor consectetur aperiam porro harum praesentium?</p>
                        <img className="pinter-cursor" src={crossbtn} onClick={() => setShowNotification(false)} style={{ height: "30px" }} alt="" />
                    </div>
      
                    {/* <Modal
                show={true}
                onHide={() => setShow(!show)}
                className=" "
                dialogClassName=" modal-90w"
                aria-labelledby="example-custom-modal-styling-title"
                >
                <Modal.Header className="border-0   m-0 p-0 " closeButton>
                <Modal.Title id="example-custom-modal-styling-title">
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Porro nihil sunt quasi sint quisquam quae iste debitis saepe officiis odit.</p>
                </Modal.Title>
                </Modal.Header>
                
            </Modal> */}

                </div>
                  }

            </>

    );
};

export default Notification;